import {
  recentPracticeIdsStorage,
  recentPracticeStorage,
  practiceStorage,
} from './localStorage'

export const getRecentPracticeIds = () =>
  JSON.parse(recentPracticeIdsStorage.get()) || []

export const getRecentPractices = () =>
  JSON.parse(recentPracticeStorage.get()) || []

export const getPractices = () =>
  JSON.parse(practiceStorage.get()) || []

export const clearRecents = () => {
  recentPracticeIdsStorage.clear()
  recentPracticeStorage.clear()
}

export const clearPracticeStatsData = () => {
  practiceStorage.clear()
  recentPracticeStorage.clear()
}

export const addPracticeToRecents = (practiceId) => {
  const recentPracticeIds = getRecentPracticeIds()
  if (!practiceId || recentPracticeIds.includes(practiceId)) return
  if (recentPracticeIds.length > 4) {
    recentPracticeIds.shift()
  }
  recentPracticeIdsStorage.set(JSON.stringify([...recentPracticeIds, practiceId]))
}



// WEBPACK FOOTER //
// ./src/services/practiceStorage.js